<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-header v-if="!projectId">
            <h1 class="m-0">
{{ $t('Issues') }}
</h1>
        </b-card-header>

        <b-card-header class="mb-0" header-bg-variant="transparent">
            <b-nav pills>
                <b-nav-item
                    :to="{ name: $route.name, params: {projectId}, query: Object.assign({}, params, { status: 'open', user_id: $auth.user().id })}"
                    exact
                    @click="assigned = null"
                >
                    {{ $t('My open') }} <b-badge>{{ meta.myOpenIssuesCount }}</b-badge>
                </b-nav-item>


                <b-nav-item exact :to="{ name: $route.name, params: {projectId}, query: Object.assign({}, params, { status: 'open', user_id: assigned ? assigned.id : undefined })}">
                    {{ $t('Open') }} <b-badge>{{ meta.openIssuesCount }}</b-badge>
                </b-nav-item>

                <b-nav-item exact :to="{ name: $route.name, params: {projectId}, query: Object.assign({}, params, { status: 'closed', user_id: assigned ? assigned.id : undefined })}">
                    {{ $t('Resolved') }} <b-badge>{{ meta.closedIssuesCount }}</b-badge>
                </b-nav-item>

                <b-nav-item exact :to="{ name: $route.name, params: {projectId}, query: Object.assign({}, params, { status: 'all', user_id: assigned ? assigned.id : undefined })}">
                    {{ $t('All') }} <b-badge>{{ meta.allIssuesCount }}</b-badge>
                </b-nav-item>
            </b-nav>
        </b-card-header>

        <b-card-header class="mb-0">
            <b-form
                class="d-flex align-items-center mx-n1"
                @submit.prevent="fetchData"
            >
                <b-form-group
                    :label="$t('Assigned')"
                    label-for="assigned"
                    class="px-1"
                >
                    <b-input-group>
                        <resource-select
                            id="assigned"
                            v-model="assigned"
                            class="w-auto"
                            no-custom-slots
                            resource="users"
                        />

                        <b-input-group-append>
                            <b-button @click="assigned = null">
                                <fa :title="$t('Reset')" icon="times" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-form-group
                    :label="$t('Search')"
                    label-for="search"
                    class="flex-grow-1 px-1"
                >
                    <b-input-group>
                        <b-form-input
                            id="search"
                            v-model="search"
                        />

                        <b-input-group-append>
                            <b-button type="submit">
                                <fa :title="$t('Search')" icon="search" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>
        </b-card-header>

        <b-card-body v-if="!pending && !items.length" class="mb-0">
            <no-results-found />
        </b-card-body>

        <b-list-group flush>
            <issues-list-item
                v-for="(issue, index) in items"
                :key="issue.id"
                v-model="items[index]"
            />
        </b-list-group>

        <b-card-footer v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                class="m-0"
            />
        </b-card-footer>

        <router-view />
    </div>
</template>

<script>
    import fetchPaginatedData from "@/mixins/fetchPaginatedData";
    import IssuesListItem from "@/components/issues/IssuesListItem";
    import ResourceSelect from "@/components/selects/ResourceSelect";

    export default {
        name: "Issues",
        components: {ResourceSelect, IssuesListItem},
        mixins: [fetchPaginatedData],
        props: {
            projectId: {
                type: [Number, String],
                default: null
            },
        },
        data() {
            return {
                resourceName: 'issues',
                assigned: null
            }
        },
        computed: {
            apiUrl() {
                if (this.projectId) {
                    return `/api/issues?project_id=${this.projectId}`
                } else {
                    return `/api/issues`
                }
            },
        },
        watch: {
            $route(newRouteValue) {
                this.params = newRouteValue.query
            },

            assigned: {
                handler(newAssignedValue, oldAssignedValue) {
                    if (!!newAssignedValue === !!oldAssignedValue) {
                        return;
                    }

                    let query = Object.assign({}, this.$route.query);
                    if (newAssignedValue) {
                        query.user_id =  newAssignedValue.id;
                    } else {
                        delete query.user_id;
                    }

                    let newRoute = Object.assign(
                        {},
                        this.$route,
                        {query},
                    );

                    this.$router.push(newRoute)
                },
                immediate: true
            }
        },
        methods: {
            listenForWebsocketEvents() {
                this.$echo.channel('issues')
                    .listen('.created', this.fetchData);
            },
        }
    }
</script>
